// @vendors
import { useEffect, useState, useContext } from "react";
import { Button, Form, Modal, Collapse, Radio } from "antd";
import cx from "classnames";
import { useParams, useHistory } from "react-router-dom";
import Context from "../../context/appContext";
import "./styles.scss";


import {
  getUrl,
  getBody,
  replaceAtrBody,
  encrypt,
  decrypt,
  getInfoField,
  getSidebarData,
  validateDiff,
  getDate,
  validateIsBefore,
  filterObject,
  getNewObject,
  replaceBrand,
  getBodyCoverage,
  paramsOfUrl,
  getUrlWithParams,
  getSidebarCoverage,
  getInfoCoverages,
  getValueField,
  newKeySituations,
} from "../../utils/utils";
import { fields } from "constants/fieldTypes";
import { ApiError, FeedbackError } from "constants/errors";
import { RichText } from "prismic-reactjs";
import { Helmet } from "react-helmet";
import jwt_decode from "jwt-decode";
import moment from "moment";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// @components
import SidebarResume from "components/fields/sidebar-resume";

// @hooks
import usePrismicByUID from "hooks/usePrismicByUID";

// @styles
import "react-multi-carousel/lib/styles.css";
import NotifyError from "components/notification-error";
import Homepage from "components/homepage";
import ModalInfo from "components/modal-info";
import QuoteNumberTitle from "components/quote-title";
import Loading from "components/loading";
import ModalLoad from "components/modal-loading";
import RadioButton from "components/fields/radio-button";
import RadioGroup from "components/fields/radio-group";
import AlertInfo from "../../components/alert-info";
import ModalAlert from "components/modal-alert";
import VehicleInspection from "components/vehicle-inspection";

export const agentEmailKey = 'correoAgente';
export const agentKey = 'agente';

export default function Quotation() {
  const [CostoInicial, setCostoInicialA] = useState(null); 
  const [CostoCosto,setCostoCosto] = useState(null);
  let history = useHistory();
  let { token } = useParams();
  const { info } = usePrismicByUID("flujo_cotizacion_v2");
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);
  const [isValidSerialNumber, setIsValidSerialNumber] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);
  const [isRedirect, setIsRedirect] = useState(false);
  const [isPaymentRedirect, setIsPaymentRedirect] = useState(false);
  const [showFinalModal, setShowFinalModal] = useState(false);
  const [tokenDecoded, setTokenDecoded] = useState(false);
  const [vehicleInspectionReady, setVehicleInspectionReady] = useState(false);
  const [isRecovering, setIsRecovering] = useState(false);
  const [checkVehicleInspection, setCheckVehicleInspection] = useState(true);
  const [attemptCounter, setAttemptCounter] = useState(0);
  const [isAgent, setIsAgent] = useState(false);
  const [persistenceModel, setPersistenceModel] = useState({});
  const [numSequence, setNumSequence] = useState();
  const [modalInfo, setModalInfo] = useState();
  const [modalAlert, setModalAlert] = useState({});
  const [emailAgent, setEmailAgent] = useState();
  const [notificationError, setNotificationError] = useState({
    visible: false,
    title: "",
    description: "",
  });
  const [form] = Form.useForm();

  const {
    product,
    productAuto,
    customRequest,
    dataForm: { data, formResponses, hiddenFields, disabledFields },
    folio,
    setFolio,
    checked,
    vehicleMake,
    formStatus: {
      steps,
      currentStep,
      currentQuestion,
      numberQuestionsStep,
      isGoToBack,
    },
    isClassActive,
    returnButton,
    disabledButtonContinue,
    tokenInfo,
    responseRequest,
    isSendForm,
    progressStep,
    homePageData,
    showHomePage,
    showAlert,
    isActive,
    setDataForm,
    setTypePerson,
    setFormStatus,
    setReturnButton,
    setIsClassActive,
    setIsActive,
    setSidebarData,
    setFormValues,
    setTokenInfo,
    insureds,
    loadingComponent,
    validateRFC,
    attempts,
    setAttempts,
    setExecuteCoverage,
    setVehicleMake,
    setIsSendForm,
    setProgressStep,
    setPriceToShow,
    setPolicyNumber,
    setInsureds,
    setHomePageData,
    setShowHomePage,
    setLoadingProcedure,
    setResponsesRequest,
    setCoverageAdd,
    setModalities,
  } = useContext(Context);

  const mapSteps = (stepsLcl, dataLcl, dataFormLcl) => {
    const fullSteps = stepsLcl.map(
      ({ key_step, name, buttonnext, returnbutton, sidebar }) => ({
        key_step,
        name,
        buttonnext,
        returnbutton,
        sidebar,
        questions: [],
      })
    );

    const stepsIndex = {};
    fullSteps.forEach(({ key_step }, index) => {
      stepsIndex[key_step] = index;
    });

    dataLcl.forEach(({ primary, items, ...rest }) => {
      const currentStepIndex = stepsIndex[primary.associated_group];
      let newItems = [];

      const stepsParentGroup =
        dataFormLcl &&
        dataFormLcl.find((value) => value.title === primary.associated_group);
      items.forEach((item) => {
        const itemField =
          item && item.fieldkey === "fakeField"
            ? { type: item.fieldkey }
            : stepsParentGroup &&
              stepsParentGroup.components.find(
                (field) => field.key === item.fieldkey
              );
        newItems.push(itemField);
      });

      if (fullSteps[currentStepIndex]) {
        fullSteps[currentStepIndex].questions = [
          ...fullSteps[currentStepIndex].questions,
          {
            primary,
            newItems,
            ...rest,
          },
        ];
      }
    });
    return fullSteps;
  };

  const getValidate = (decode) =>{
    let validate = true
    if (numSequence) {
     Object.values(newKeySituations[2]).forEach((person)=>{
        if(tokenInfo[person]!==decode[person]){
            validate = false
        }
     });
    }  
    return validate
}

  const getUserInfo = (value) => {
    let decode = jwt_decode(value);
    if (decode && !decode.ramoId) {
      const productValues = JSON.parse(
        process.env.REACT_APP_CHANNEL_VALUES_DIRECT
      );
      decode["ramoId"] = productValues.ramo;
    }
    setTokenInfo(getValidate(decode)?decode:tokenInfo);
    setTokenDecoded(true);
  };

  const keysHidden = [
    "identificadorPersonaContratanteMoral",
    "fechaDeConstitucionContratante",
  ];

  const keysMessage = {
    1: "El RFC capturado no es válido, por favor revisa tus datos.",
    2: "Tu RFC no coincide con los datos ingresados, por favor revisa tus datos",
    3: "Tu RFC no coincide con los datos ingresados, ¿estas seguro que es correcto?",
  };

  const keysStep = {
    step_emision: true,
    step_emision_asegurado: true,
    step_emision_contratante: true,
    step_vigencia_poliza: true,
  };

  useEffect(() => {
    if (CostoInicial !== null) {
      setCostoCosto(CostoInicial);
    }
  }, [CostoInicial]); 

  useEffect(() => {
    const localToken = localStorage.getItem(`localToken_${productAuto}`);
    if (token && token.length > 0) {
      const tokenDecode = jwt_decode(token);
      if (
        (tokenDecode && tokenDecode.origen === "externo") ||
        tokenDecode.origen === "pasarela"
      ) {
        setIsPaymentRedirect(tokenDecode.origen === "pasarela");
        const dataDecrypt = decrypt(
          tokenDecode.value,
          process.env.REACT_APP_RECOTIZADORES_KEY
        );
        const tokenData =
          dataDecrypt && dataDecrypt.length > 0 && JSON.parse(dataDecrypt);
        history.replace(`/${productAuto}/`);
        setLoadingProcedure({ visible: true, message: "Recuperando tramite" });
        const dataObject = {
          oficina: tokenData.oficinaId,
          ramoId: tokenData.ramoId,
          userId: tokenData.usuarioId,
          email: tokenData.email,
          id: tokenData.cotizacionId,
          origen: tokenDecode.origen,
          isCallCenter: tokenDecode.isCallCenter,
        };
        setTimeout(() => {
          setNumSequence(dataObject);
        }, 10000);

        if(tokenData && tokenData.usuarioId ){
          const { email } = tokenData;
          setEmailAgent(email);
        }

      } else {
        localStorage.setItem(
          `localToken_${productAuto}`,
          JSON.stringify(token)
        );
        getUserInfo(token);
      }
    } else if (localToken && !tokenInfo.usuarioId) {
      getUserInfo(JSON.parse(localToken));
    }
    if (tokenInfo && tokenInfo.usuarioId && tokenDecoded) {
      //setShowHomePage(false);
      history.replace(`/${productAuto}/`);
      const { email } = tokenInfo;
      setDataForm((dataForm) => ({ ...dataForm, formResponses: [{ key:'correoAgente', value: email}] }));
    }
  }, [token, tokenInfo]);

  useEffect(() => {
    isSendForm && sendForm();
    setIsSendForm(false);
  }, [isSendForm]);

  useEffect(() => {
    if (responseRequest && Object.keys(responseRequest).length > 0) {
      setPersistenceModel((persistenceModelLcl) => ({
        ...persistenceModelLcl,
        cotizaciones: responseRequest.cotizacion,
      }));
      setProgressStep([...progressStep]);
    }
  }, [responseRequest]);

  useEffect(() => {
    if (insureds && insureds.length > 0) {
      setPersistenceModel((persistenceModelLcI) => ({
        ...persistenceModelLcI,
        insureds: insureds,
        insuredsActive: isActive,
      }));
      setProgressStep([...progressStep]);
    }
  }, [insureds]);

  useEffect(async () => {
    if (
      persistenceModel &&
      persistenceModel.componentes &&
      persistenceModel.componentes.length > 0
    ) {
      const copyPersistenceModel = { ...persistenceModel };
      delete copyPersistenceModel._id;
      copyPersistenceModel.configuracion.estadoBarraProgreso = progressStep;
      copyPersistenceModel.configuracion.fechaModificacion = moment(
        new Date()
      ).format("YYYY-MM-DD HH:mm:ss");
      const serviceOptions = JSON.parse(
        process.env.REACT_APP_INSERT_RESPONSES_SERVICE
      );
      const url = `${process.env.REACT_APP_PATH}/${serviceOptions.url}`;
      copyPersistenceModel.configuracion.folio = folio;
      const resp = await customRequest(
        url,
        serviceOptions.headers,
        serviceOptions.method,
        copyPersistenceModel
      );
      const { agenteId } = resp?.respuesta?.value?.datosAgente ?? {};
      setIsAgent(!!agenteId);      
      setIsRedirect(showFinalModal);
    }
  }, [progressStep]);

  useEffect(async () => {
    if (!numSequence && info && data && data.formDefinition) {
      data &&
        data.persistenceModel &&
        setPersistenceModel({ ...data.persistenceModel });
      setHomePageData({
        logo: info.data.logo,
        links:
          tokenInfo && tokenInfo.usuarioId ? null : info.data.headermenulinks,
      });
      setPersistenceModel((persistenceModelLcl) =>
        persistenceModelLcl.datosAgente
          ? { ...persistenceModelLcl, datosAgente: tokenInfo }
          : { ...persistenceModelLcl }
      );
      setFormStatus({
        steps: mapSteps(
          info.data.orderbysteps,
          info.data.body,
          data.formDefinition.components
        ),
        currentStep,
        currentQuestion,
        numberQuestionsStep,
      });
    }
  }, [info, data]);

  useEffect(async () => {
    if (numSequence && info && data && data.formDefinition) {
      setLoadBtn(true);
      const serviceOptions = JSON.parse(
        process.env.REACT_APP_FIND_RESPONSES_SERVICE
      );
      const encryptedData = encrypt(
        JSON.stringify(numSequence),
        serviceOptions.key
      );
      const url = `${process.env.REACT_APP_PATH}${serviceOptions.url}?data=${encryptedData}`;
      let message = "";
      const response = await customRequest(
        url,
        serviceOptions.headers,
        serviceOptions.method,
        {}
      );
      if (
        response &&
        response.tipo_estado &&
        response.tipo_estado === "exito" &&
        response.respuesta
      ) {
        if (
          (response.respuesta.configuracion &&
            response.respuesta.configuracion.estadoFlujo === "Activo") ||
          response.respuesta.configuracion.estadoFlujo === "Pendiente"
        ) {
          const responseModel = { ...response.respuesta };
          delete responseModel._id;
          if (!isPaymentRedirect && validateIsBefore(responseModel).isBefore) {
            setPersistenceModel(responseModel);
            setShowFinalModal(true);
          } else {
            let responseSteps =
              responseModel.componentes &&
              responseModel.componentes.length > 0 &&
              responseModel.componentes;
            const formCurrentStatus =
              responseModel.configuracion &&
              responseModel.configuracion.ultimaPersistencia;
            const datosAgente = responseModel.datosAgente;
            const statusProgressStepLcl =
              responseModel.configuracion &&
              responseModel.configuracion.estadoBarraProgreso;
            const insuredsResponse =
              responseModel.insureds && responseModel.insureds.length > 0
                ? responseModel.insureds
                : [];

            setInsureds(insuredsResponse);
            setIsClassActive(responseModel?.coveragesActive);
            setIsActive(
              responseModel.insuredsActive ? responseModel.insuredsActive : []
            );
            setProgressStep(statusProgressStepLcl);
            setTokenInfo(datosAgente);
            setFolio(responseModel.configuracion.folio);
            setResponsesRequest({
              cotizacion: responseModel.cotizaciones
                ? responseModel.cotizaciones
                : [],
            });
            data && data.persistenceModel && setPersistenceModel(responseModel);

            if(emailAgent){
              if(responseSteps.find((e) => e.key === agentEmailKey)) {
                responseSteps = responseSteps?.map(item => {
                  if (item.key === agentEmailKey) {
                      return { ...item, value: emailAgent };
                  }
                  return item;
                }) 
              }
              else {
                responseSteps.push({ key: agentEmailKey, value: emailAgent })
              }
            }

            setDataForm((dataForm) => ({
              ...dataForm,
              formResponses: responseSteps,
            }));
            setTypePerson(false);
            const searchModalitie = responseSteps.find(
              (res) => res.key === "coberturas"
            );
            const vehicle = responseModel.componentes.find(
              (e) => e.key === "vehiclemake"
            );
            if (vehicle) {
              setVehicleMake(vehicle.description);
            }
            if (searchModalitie && searchModalitie.coverages) {
              const dataSideBar = getSidebarCoverage(
                searchModalitie,
                responseSteps
              );
              setSidebarData(dataSideBar);
              setCoverageAdd(
                searchModalitie.coveragesAdd ? searchModalitie.coveragesAdd : []
              );
              setModalities(
                searchModalitie.modalities ? searchModalitie.modalities : []
              );
            }
            if (
              await requote(
                statusProgressStepLcl,
                responseModel,
                responseSteps,
                datosAgente
              )
            ) {
              setFormStatus({
                steps: getAllSteps(
                  data.formDefinition.components,
                  responseSteps
                ),
                currentStep: formCurrentStatus.currentStep,
                currentQuestion: formCurrentStatus.currentQuestion,
                numberQuestionsStep: formCurrentStatus.numberQuestionsStep,
              });
            }
          }
        } else {
          message = `Ya ha finalizado el tramite con el folio o número de cotización ${numSequence.id}`;
          if (
            response.respuesta.configuracion.estadoFlujo === "transferencia"
          ) {
            message = `El tramite con el folio o número de cotización ${numSequence.id} ya se encuentra cerrado`;
          }
        }
      } else {
        message = `No existen datos para el tramite con el folio o número de cotización ${numSequence.id}`;
      }
      message && showModal({ renderMessage: { title: "Ops!", body: message } });
      if (!message) {
        setHomePageData({ ...homePageData, links: null });
        setShowHomePage(false);
      }
      setLoadBtn(false);
      setLoadingProcedure({ visible: false, message: "" });
    }
  }, [numSequence]);

  useEffect(() => {
    showAlert && showAlert.renderMessage && showModal(showAlert);
  }, [showAlert]);

  const requote = async (
    statusStep,
    responseModel,
    responseSteps,
    datosAgente
  ) => {
    setIsRecovering(true);
    setReturnButton(false);
    setLoading(true);
    let result = true;
    const valStep =
      statusStep &&
      statusStep.filter((st) => keysStep[st.key_step] && st.active);

    if (valStep && valStep.length > 0) {
      result = false;
      const allComponents = data.formDefinition.components;
      const quoteField = getInfoField(
        "coberturas",
        "step_cobertura",
        allComponents
      );
      const options =
        quoteField && quoteField.content ? JSON.parse(quoteField.content) : {};
      const body = getBodyCoverage(
        responseSteps,
        getValueField("folio", responseSteps),
        datosAgente,
        true
      );
      const res = await customRequest(
        options.url,
        options.headers,
        options.method,
        body
      );

      if (res && res.data && res.data.policy) {
        data["infoRequote"] = { res, infoRequest: options };
        result = true;
        const policy = res.data.policy;
        setPolicyNumber(policy.policyNumber);
        setPriceToShow(res.data.costs.amount);
        setModel(policy);
        //openFinalModal(valStep, responseModel, statusStep);
        showModal({
          renderMessage: {
            title: "Gracias por continuar tu trámite",
            body: "El costo del seguro se ha actualizado",
          },
        });
      }
    }
    keyStep!=='step_emision_asegurado' && setReturnButton(true);
    setLoading(false);
    return result;
  };

  const openFinalModal = (valStep, responseModel, statusStep) => {
    if (!isPaymentRedirect) {
      const finalStep = valStep.find(
        (y) => y.key_step === "step_emision_contratante"
      );
      const statusPayment =
        responseModel &&
        responseModel.payment &&
        responseModel.payment.length > 0 &&
        responseModel.payment[responseModel.payment.length - 1]; //Obtener el último estado del pago
      if (
        finalStep &&
        finalStep.key_step &&
        statusPayment &&
        (statusPayment.payment.status || statusPayment.status) !== "canceled"
      ) {
        const isUrlPayment = responseModel && responseModel.urlPayment;
        const lastUrl = isUrlPayment && isUrlPayment[isUrlPayment.length - 1];
        setShowFinalModal(lastUrl && lastUrl.validity.length);
      }
    } else if (
      responseModel &&
      responseModel.urlPayment &&
      responseModel.urlPayment.length > 0
    ) {
      const copyUrlPayment = JSON.parse(
        JSON.stringify(responseModel.urlPayment)
      );
      copyUrlPayment[copyUrlPayment.length - 1].validity = false;
      setPersistenceModel((persistenceModelRD) => ({
        ...persistenceModelRD,
        urlPayment: copyUrlPayment,
      }));
      setProgressStep(statusStep);
    }
  };

  const getAllSteps = (components, responseSteps) => {
    const newComponents = JSON.parse(JSON.stringify(components));
    newComponents &&
      newComponents.forEach((item, index) => {
        item &&
          item.components.forEach((itemComponent, i) => {
            const responseItem =
              responseSteps &&
              responseSteps.find((x) => x.key === itemComponent.key);
            if (responseItem && Object.keys(responseItem).length > 0) {
              newComponents[index].components[i].value = responseItem.value;
            }
          });
      });
    return mapSteps(info.data.orderbysteps, info.data.body, newComponents);
  };

  useEffect(() => {
    setFormStatus({
      steps,
      currentStep,
      currentQuestion,
      numberQuestionsStep: steps[currentStep]?.questions.length,
    });
  }, [steps]);

  useEffect(() => {
    generateFolio();
  }, [folio]);

  const generateFolio = async () => {
    const iFolio = formResponses.findIndex((item) => item.key === "folio");
    if (iFolio !== -1 && folio) {
      const nFolio = folio;
      formResponses[iFolio].value = nFolio;
      const fechaCreacion = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      const formStatusValue = isGoToBack
        ? {
            currentStep: currentStep,
            currentQuestion:
              currentQuestion < numberQuestionsStep ? currentQuestion : 0,
            numberQuestionsStep: numberQuestionsStep,
          }
        : {
            currentStep: 0,
            currentQuestion:
              currentQuestion < numberQuestionsStep - 1
                ? currentQuestion + 1
                : 0,
            numberQuestionsStep: numberQuestionsStep,
          };
      setPersistenceModel((objPersistenceModel) => ({
        ...objPersistenceModel,
        componentes: formResponses,
        configuracion: {
          ...objPersistenceModel.configuracion,
          folio: nFolio,
          estadoFlujo: "Activo",
          fechaCreacion: fechaCreacion,
          ultimaPersistencia: formStatusValue,
        },
      }));
      setProgressStep([...progressStep]);
    }
  };

  const nextStep = async () => {
    if(keyStep=='step_emision' && !isValidSerialNumber) return
    validateCallServiceOrExecuteFunction(() => {
      sendRequest({
        steps,
        currentQuestion: 0,
        currentStep: currentStep + 1,
        numberQuestionsStep: steps[currentStep + 1]?.questions.length,
      });
    });
    /*de aqui mandaremos a llamar funcion que contendra nuestro swicht*/
    funcionTagManager(steps,currentStep);
    };

    function funcionTagManager(steps, currentStep){
     switch(currentStep){
      case 0:
        const obtenermodelo = persistenceModel.componentes.find(objeto => objeto.key==='model').value;        
        const obtenervserion = persistenceModel.componentes.find(objeto => objeto.key==='versionVehiculo').value.description;
          window.dataLayer.push ({
          'event' : 'mov_02_vehiculo_detalles',
          'modelo' : obtenermodelo,
          'version' : obtenervserion
        })
      break;
      case 1:
        window.dataLayer.push({ 
        'event' : 'mov_03_datos_pers_1'
        });
      break;
      case 2:
        window.dataLayer.push({ 
        'event' : 'mov_04_datos_pers_2'
        });
      break;       
      case 4:          
        let coberturas = persistenceModel.componentes.find((objeto1) => objeto1.key.toLowerCase() === "coberturas").coverages;
        let cobAdicionalesTxt = '';
        coberturas.forEach((objeto, index) => {
          if (objeto.choosed) {
            cobAdicionalesTxt += objeto.coverageName;           
            if (index < coberturas.length - 1) {
              cobAdicionalesTxt += ', ';
            }
          }
        });
        const agenteodirecto = persistenceModel.datosAgente.name;        
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push({
         event: "add_to_cart",
         ecommerce: {
         currency: "MXN",
         value: CostoCosto,
         items: [
          {
           item_id: "Movilidad", // Incluir SKU que indique el sistema
           item_name: "Seguro de movilidad total",
           affiliation: agenteodirecto, // y SURA Agente cuando es B2B
           item_brand: "SURA",
           item_category: "Movilidad",
           item_variant: cobAdicionalesTxt, // Depende de los beneficios agregados, ejemplo: “Llantas y rines protegidos, Trámites desde casa”.
           location_id: "ChIJIQBpAG2ahYAR_61",
           price: CostoCosto, // Precio varía dependiendo de los beneficios opcionales que se agreguen (y que se verán reflejados en el campo item_variant)
           quantity: 1
           }
          ]
        }
        });
        window.dataLayer.push({
        'event' : 'mov_06_beneficios',
        'beneficios' : cobAdicionalesTxt  // Depende de los beneficios agregados
        });
      break;
      case 5:        
         window.dataLayer.push({ 
          'event' : 'mov_07_vehiculo_n_serie' 
          });
      break;
      case 6: 
      const agenteodirectoa = persistenceModel.datosAgente.name;      
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
          currency: "MXN",
          value: "",
        items: [
          {
        item_id: "Movilidad", // Incluir SKU que indique el sistema
        item_name: "Seguro de movilidad total",
        affiliation: agenteodirectoa, // y SURA Agente cuando es B2B
        item_brand: "SURA",
        item_category: "Movilidad",        
        location_id: "ChIJIQBpAG2ahYAR_61",
        price: CostoCosto,
        quantity: 1
        }
      ]
      }
    }); 
       window.dataLayer.push({ 
        'event' : 'mov_08_datos_asegurado' 
        });       
      break;
      case 7:
        const agenteodirectoc = persistenceModel.datosAgente.name;        
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push({
         event: "add_shipping_info",
         ecommerce: {
         currency: "MXN",
         value: CostoCosto,
         shipping_tier: "Virtual", //Dado que no hay una entrega física (confirmar) podemos dejar el campo de esa manera, y cambiarlo a futuro de ser necesario
       items: [
        {
        item_id: "Movilidad", // Incluir SKU que indique el sistema
        item_name: "Seguro de movilidad total",
        affiliation: agenteodirectoc, // y SURA Agente cuando es B2B
        item_brand: "SURA",
        item_category: "Movilidad",       
        location_id: "ChIJIQBpAG2ahYAR_61",
        price: CostoCosto,
        quantity: 1
        }
      ]
      }
      });
        window.dataLayer.push({
          'event' : 'mov_09_datos_contratante' 
          });
      break;
      case 8:
        window.dataLayer.push({ 
          'event' : 'mov_10_vigencia' 
          });
      break; 
     default:
      console.log("Opcion no reconocida");               
           
  };
};

  const nextStepQuestion = async () => {
    validateCallServiceOrExecuteFunction(() => {
      sendRequest({
        steps,
        currentStep,
        currentQuestion: currentQuestion + 1,
        numberQuestionsStep,
      });
    });
  };


  const validateCallServiceOrExecuteFunction = async (callback) => {
    let arrayValidations = [];
    const indexBenef = getCurrentQuestions().newItems.findIndex(
      (val) => val.key && val.key === "asegurados"
    );
    if (indexBenef !== -1 && (await validateForm())) {
      if (Object.keys(form.getFieldsValue()).length === 0) {
        if (insureds && insureds.length > 1) {
          const children = insureds.filter((x) => x.type !== "T");
          children.forEach((insured, index) => {
            const insuredAge = getDate(insured.age);
            const infoF = getCurrentQuestions().newItems[indexBenef];
            const dateField = infoF.components.find(
              (x) => x.key === "fechaNacimientoAsegurado"
            );
            arrayValidations[index] = validateDiff(
              insured.type,
              dateField,
              insureds,
              insuredAge
            );
          });
          if (arrayValidations.find((x) => x === true)) {
            setNotificationError({
              visible: true,
              title: "No es posible continuar",
              description: "Valida la información de los asegurados.",
            });
          } else {
            setNotificationError({ visible: false });
            sendForm();
            callback();
          }
        } else {
          setNotificationError({
            visible: true,
            title: "Por favor, agrega al menos un asegurado adicional",
            description: "",
          });
        }
      }
    } else if (
      getCurrentQuestions().newItems.findIndex(
        (val) => val.key === "infoAsegurados"
      ) !== -1
    ) {
      if (insureds && insureds.length <= 1) {
        const fieldsValues = filterObject(form.getFieldsValue(), "Titular");
        const fKey = Object.keys(filterObject(fieldsValues, "identificador"));
        const insuredId = fKey && fKey[0] && fKey[0].split("-")[1];
        if (
          (await validateForm()) &&
          (await validateRFC(getNewObject(fieldsValues, "Titular", insuredId)))
        ) {
          setIsActive({ ...isActive });
          sendForm();
          callback();
        }
      } else {
        const keysInsureds = insureds && insureds.map((ik) => ik.key);
        const result =
          keysInsureds &&
          keysInsureds.every((i) => {
            return isActive[i] === true;
          });
        if ((await validateForm()) && result) {
          sendForm();
          callback();
        }
      }
    } else if (await validateForm()) {
      sendForm();
      callback();
    }
  };

  const serialNumber = formResponses?.find((item) => item.key === "serialNumber")?.value
  const keyStep = steps?.[currentStep]?.key_step

  useEffect(() => {
    setIsValidSerialNumber(false)
  }, [serialNumber])

  useEffect(() => {
    if(keyStep=='step_emision_contratante') setReturnButton(true);
    if(keyStep=='step_emision_asegurado') setReturnButton(false);
    if(keyStep=='step_emision') setFormStatus((prev) => ({...prev, isGoToBack: false}));
    if(keyStep=='step_emision' && isRecovering) setAttemptCounter((prev) => prev + 1)
  }, [keyStep]);
  
  useEffect(() => {
    if(keyStep=='step_inspeccion_vehicular' && !checkVehicleInspection) nextStep();
  }, [keyStep, checkVehicleInspection]); 

  useEffect(() => {
    if(!isValidSerialNumber && keyStep=='step_emision') {
      form.resetFields();
    }
  }, [isValidSerialNumber])

  const validateSerie = async() => {
    const { validate } = formResponses?.find((item) => item.key === "serialNumber") ?? {};
    const { minLength, maxLength } = validate ?? {}
    const {serialNumber} = filterObject(form.getFieldsValue(), "serialNumber") ?? {};
    if(!serialNumber || !(serialNumber?.length >= minLength) || !(serialNumber?.length <= maxLength)) return;
    setValidating(true)
    disabledFields['serialNumber'] = true

    const valPrimary =
      steps[currentStep] &&
      steps[currentStep].questions[currentQuestion] &&
      steps[currentStep].questions[currentQuestion].primary;
    let url = "";

    url = getUrl(valPrimary.opciones_servicio, formResponses);
    const response = await customRequest(
      url.url,
      url.headers,
      url.method
    );

    let info = {
      icon: 'fa-user',
      title: "",
      description: "",
      buttonText: "Aceptar",
      visible: true,
      onConfirm: () => {
        setModalAlert({ visible: false });
      }
    }

    if(response.toString().includes(ApiError.failedFetch) || response.statusCode === 500){
      info.icon = 'fa-circle-xmark';
      info.iconColor = '#d12d35';
      info.title = FeedbackError.failedFetch.title;
      info.description = FeedbackError.failedFetch.desc;
      setModalAlert(info); 
      setValidating(false)
      disabledFields['serialNumber'] = false
      return
    }

    if(!response?.data){
      info.title = FeedbackError.existingPolicy.title;
      info.description = FeedbackError.existingPolicy.desc;
      setModalAlert(info); 
      setValidating(false)
      disabledFields['serialNumber'] = false
      return
    }

    url = `${process.env.REACT_APP_PATH}validate-vin`
    const headers = {"Content-Type":"application/json"}
    const method = 'POST'
    const resp = await customRequest(
      url,
      headers,
      method,
      {folio, vin: serialNumber}
    );

    const {respuesta, tipo_estado}= resp ?? {}
    const {success, checkVehicleInspection}= respuesta ?? {}
    disabledFields['serialNumber'] = false
    setCheckVehicleInspection(checkVehicleInspection);

    if(resp.toString().includes(ApiError.syntax) || tipo_estado == ApiError.technical){
      info.icon = 'fa-circle-xmark';
      info.iconColor = '#d12d35';
      info.title = FeedbackError.failedFetch.title;
      info.description = FeedbackError.failedFetch.desc;
      setModalAlert(info); 
      setValidating(false)
      disabledFields['serialNumber'] = false
      return
    }

    if(!success){
      info.title = FeedbackError.cannotBeInsured.title;
      info.description = FeedbackError.cannotBeInsured.desc;
      info.onConfirm= () => {
        window.location.reload();
      }
      setModalAlert(info); 
      setValidating(false);
      return
    }

    setValidating(false)
    setIsValidSerialNumber(true)
  }

  const sendForm = () => {
    setNotificationError({ visible: false });
    const currentStepValue = steps && steps[currentStep];
    if (currentStepValue && Object.keys(currentStepValue).length > 0) {
      const formStatusValue = isGoToBack
        ? {
            currentStep: currentStep,
            currentQuestion:
              currentQuestion < numberQuestionsStep ? currentQuestion : 0,
            numberQuestionsStep: numberQuestionsStep,
          }
        : {
            currentStep:
              currentQuestion < numberQuestionsStep - 1
                ? currentStep
                : currentStep + 1,
            currentQuestion:
              currentQuestion < numberQuestionsStep - 1
                ? currentQuestion + 1
                : 0,
            numberQuestionsStep: numberQuestionsStep,
          };

      setPersistenceModel((persistenceModelLcl) => ({
        ...persistenceModelLcl,
        componentes: formResponses,
        coveragesActive: isClassActive,
        configuracion: {
          ...persistenceModelLcl.configuracion,
          ultimaPersistencia: formStatusValue,
        },
      }));
    }
  };

  const sendRequest = async (setForm) => {
    setLoading(true);
    const valPrimary =
      steps[currentStep] &&
      steps[currentStep].questions[currentQuestion] &&
      steps[currentStep].questions[currentQuestion].primary;
    let url = "";
    if (paramsOfUrl[valPrimary.associated_group]) {
      url = getUrlWithParams(
        JSON.parse(valPrimary.opciones_servicio),
        paramsOfUrl[valPrimary.associated_group],
        formResponses,
        valPrimary.associated_group
      );
    } else {
      url = getUrl(
        valPrimary && valPrimary.opciones_servicio
          ? valPrimary.opciones_servicio
          : "",
        formResponses
      );
    }
    let isShowModalInfo = true;
    if (url && keyStep !== 'step_emision') {
      let body = {};
      if (url.method === "POST") {
        if (valPrimary.associated_group === "step_adicionales") {
          body = getBodyCoverage(formResponses, folio, tokenInfo, true);
        } else {
          body = getBody(
            url.body,
            data.modelConfig,
            formResponses,
            insureds,
            tokenInfo,
            isClassActive
          );
        }
      }
      if (body && body.poliza) {
        body.poliza = replaceAtrBody(body.poliza, tokenInfo);
      }
      if (folio && body && body.configuration) {
        body.configuration.folio = folio;
      }
      const isInsert = url.url.includes("insert");
      !isInsert && setReturnButton(false);
      const response = await customRequest(
        url.url,
        url.headers,
        url.method,
        body
      );

      if (
        (response && response.success) ||
        response.tipo_estado === "exito" ||
        response.status_type === "exito" ||
        response.data
      ) {
        const iAgente = formResponses.findIndex(
          (item) => item.key === "agente"
        );
        if (iAgente !== -1) {
          formResponses[iAgente].value =
            tokenInfo && tokenInfo.usuarioId ? "true" : "false";
        }
        if (response && response.status && !numSequence) {
          const indexStatus = formResponses.findIndex(
            (item) => item.key === "status"
          );
          const indexFolio = formResponses.findIndex(
            (item) => item.key === "folio"
          );
          if (indexStatus != -1) {
            const value = formResponses[indexStatus].value;
            formResponses[indexStatus].value = response.status
              ? response.status
              : value;
            const numFolio = data && data.modelFolio.numFolio;
            formResponses[indexFolio].value = numFolio;
            const fechaCreacion = moment(new Date()).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            setFolio(numFolio);
            setPersistenceModel((persistenceModelLcl) =>
              persistenceModelLcl.configuracion
                ? {
                    ...persistenceModelLcl,
                    configuracion: {
                      ...persistenceModelLcl.configuracion,
                      folio: numFolio,
                      estadoFlujo: "Activo",
                      fechaCreacion: fechaCreacion,
                    },
                  }
                : { ...persistenceModelLcl }
            );
          }
        }

        if (
          (response && response.respuesta && response.respuesta.policy) ||
          (response.data && response.data.policy)
        ) {
          const policy = response.respuesta
            ? response.respuesta.policy
            : response.data.policy;
          setCostoInicialA(response.data.costs.amount);
          setPolicyNumber(policy.policyNumber);
          setPriceToShow(response.data.costs.amount);
          setModel(policy);
          data["infoRequote"] = { res: response, infoRequest: url };
        }
        setFormStatus(setForm);
      } else {

        if(response.toString().includes(ApiError.failedFetch) || response.statusCode === 500) {
          const info = {
            icon: 'fa-circle-xmark',
            iconColor: '#d12d35',
            title: FeedbackError.failedFetch.title,
            description: FeedbackError.failedFetch.desc,
            buttonText: "Aceptar",
            visible: true,
            onConfirm: () => {
              setModalAlert({ visible: false });
            }
          }
          setModalAlert(info); 
          setValidating(false);
          setLoading(false);
          !isInsert && keyStep!=='step_emision_asegurado' && setReturnButton(true);
          return;
        }

        isShowModalInfo = !response || !response.message;
        showModal(response, setForm);
      }
      !isInsert && keyStep!=='step_emision_asegurado' && setReturnButton(true);
    } else {
      setFormStatus(setForm);
    }
    isShowModalInfo && showModalInfo();
    setLoading(false);
  };

  const setModel = (policy) => {
    if (policy && Object.keys(policy).length > 0) {
      data.modelConfig["polizaCotizacion"] = {
        oficina: policy.officeId,
        ramo: policy.productId,
        estado: "W",
        poliza: policy.policyNumber,
        suplemento: 0,
        rfc: "XXXXXXX",
      };
    }
  };

  const showModalInfo = () => {
    const finalModal = getCurrentQuestions()?.primary.finalmodal;
    if (finalModal) {
      sendForm();
      const dataModalInfo = JSON.parse(finalModal);
      dataModalInfo.visible = true;
      setModalInfo(dataModalInfo);
    }
  };

  const showModal = (response, formSet) => {
    let btnDescription = undefined;
    let btnOkText = "Aceptar";
    if (
      response &&
      response.renderMessage &&
      response.renderMessage.body?.includes("RFC")
    ) {
      let updateAttemps = 0;
      if (attempts === 3) {
        setAttempts(updateAttemps);
      }
      updateAttemps = attempts === 3 ? updateAttemps + 1 : attempts + 1;
      if (updateAttemps === 3) btnDescription = "Si";
      setAttempts(updateAttemps);
      response.renderMessage.body = keysMessage[updateAttemps];
      btnOkText = "Revisar";
    }
    if (response && response.errors) {
      response["message"] = response.errors.description;
    }
    const message = response.renderMessage
      ? response.renderMessage
      : response.message && {
          renderMessage: { title: "Error", body: response.message },
        };
    setLoading(false);
    if (response && message) {
      Modal.info({
        icon: "",
        title: message.title ? message.title : message.renderMessage.title,
        className: "modal-confirm",
        closable: true,
        okButtonProps: {
          className: "ant-btn-solid c-2 ant-btn-size-xs",
        },
        cancelButtonProps: {
          className: "ant-btn-solid c-2 ant-btn-size-xs",
        },
        okText: btnOkText,
        okCancel: btnDescription,
        cancelText: btnDescription,
        content: (
          <p>{message.body ? message.body : message.renderMessage.body}</p>
        ),
        onOk() {},
        onCancel(eve) {
          if (
            (formSet && !eve?.triggerCancel)
          ) {
            setFormStatus(formSet);
            showModalInfo();
            setLoading(false);
            eve()
          }
        },
      });
    }
  };

  const validateForm = () => {
    if (checked) {
      form.resetFields(keysHidden);
    }
    return form
      .validateFields()
      .then(() => {
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  const getBtnId = () => {
    const current = getCurrentQuestions();
    const btnId =
      current && current.primary && current.primary.associated_group
        ? `${current.primary.associated_group}-q${currentQuestion + 1}`
        : "btn-q1";
    return btnId;
  };

  const getCurrentQuestions = () => {
    return (
      steps[currentStep] &&
      JSON.parse(JSON.stringify(steps[currentStep].questions[currentQuestion]))
    );
  };

  const handleChange = (valNumSequence) => {
    const channelValues = JSON.parse(
      process.env.REACT_APP_CHANNEL_VALUES_DIRECT
    );
    const objectFilters = {
      oficina: channelValues && channelValues.oficina,
      ramoId: channelValues && channelValues.ramo,
      userId: null,
      id: valNumSequence,
      email: process.env.REACT_APP_DEFAULT_EMAIL,
      origen: "direct",
    };
    valNumSequence && setNumSequence(objectFilters);
    if (!valNumSequence) {
      setHomePageData({ ...homePageData, links: null });
      setShowHomePage(false);
      document.getElementById("top")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const validateHomePage = () => {
    let showHome = true;
    if (info && info.data) {
      showHome = info.data.showhomepage;
    }
    setShowHomePage(showHome);
    return showHome;
  };

  const continueBtn = () => {
    const handleContinue = async () => {
      const currentStepKey = steps[currentStep]?.key_step;

      if(currentStepKey === "step_inspeccion_vehicular" && !vehicleInspectionReady) return;
        
      if(currentStepKey === "step_adicionales") {
        const info = {
          icon: "fa-exclamation-circle",
          iconColor: "green",
          title: "¡Importante!",
          description: isAgent ? "Recuerda que con tu folio puedes recuperar tu trámite en cualquier momento" : 'Es necesario que estés cerca de tu vehículo y tengas tu tarjeta de circulación a la mano',
          buttonText: "Aceptar",
          info: `Folio: ${folio}`,
          visible: true,
          onConfirm: () => {
            setModalAlert({ visible: false });
            nextStep();
          }
        }
        setModalAlert(info);        
      }
      else nextStep();
    };
    return (
      steps[currentStep] &&
      steps[currentStep].questions[currentQuestion].primary.buttonnext ===
        "Si" &&
      !(loadingComponent.visible && loadingComponent.active) && (
        <div className="question-container__actions">
          <div className="question-container__actions-left" />
          <div className="question-container__actions-right">
            {currentQuestion + 1 === numberQuestionsStep &&
              currentStep + 1 !== steps.length && (
                <Button
                  id={getBtnId()}
                  loading={loading}
                  className="ant-btn-solid c-3 ant-btn-size-md"
                  onClick={handleContinue}
                  disabled={disabledButtonContinue}
                >
                  <strong>Continuar</strong>
                </Button>
              )}
            {currentQuestion + 1 !== numberQuestionsStep && (
              <Button
                id={getBtnId()}
                loading={loading}
                className="ant-btn-solid c-3 ant-btn-size-md"
                onClick={() => nextStepQuestion()}
                disabled={disabledButtonContinue}
              >
                <strong>Continuar</strong>
              </Button>
            )}
            {currentStep === steps.length - 1 &&
              currentQuestion + 1 === numberQuestionsStep && (
                <Button
                  id={getBtnId()}
                  loading={loading}
                  disabled={disabledButtonContinue}
                  className="ant-btn-solid c-3 ant-btn-size-md"
                  onClick={async () => {
                    const allData = getBody(
                      {},
                      data.modelConfig,
                      formResponses,
                      [],
                      {},
                      {}
                    );
                    const personalData =
                      allData && allData.client && allData.client.personalData;
                    setShowFinalModal(await validateForm());
                  }}
                >
                  <strong>Contratar</strong>
                </Button>
              )}
          </div>
        </div>
      )
    );
  };

  return showHomePage && validateHomePage() ? (
    <Homepage
      data={info && info.data && info.data.homepagecontent}
      handleChange={handleChange}
      loadBtn={loadBtn}
    />
  ) : (
    info && info.data && (
      <GoogleReCaptchaProvider
        reCaptchaKey={info.data.recaptchakey}
        language="es"
      >
        <div className="container-xl">
          <div className="question-container">
            <Helmet>
              <meta charSet="utf-8" />
            </Helmet>
            {loadingComponent.visible && loadingComponent.active ? (
              <Loading />
            ) : (
              <div className="question-container__steps">
                {showFinalModal && (
                  <ModalLoad
                    persistenceM={persistenceModel}
                    setPersistenceModel={setPersistenceModel}
                    isRedirect={isRedirect}
                    setIsRedirect={setIsRedirect}
                    isPaymentRedirect={isPaymentRedirect}
                  />
                )}
                {modalInfo && modalInfo.visible && (
                  <ModalInfo info={modalInfo} />
                )}
                
                <ModalAlert info={modalAlert} />
                
                {notificationError.visible && (
                  <NotifyError
                    title={notificationError.title}
                    description={notificationError.description}
                  />
                )}
                {getCurrentQuestions() && (
                  <Form
                    form={form}
                    onFieldsChange={setFormValues}
                    className={cx(
                      `question-container__steps-body ${
                        document.getElementsByClassName("sidebar-resume__open")
                          .length > 0 && "column-reverse"
                      }`,
                      {
                        "question-container__steps-body-columns-1":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "1",
                        "question-container__steps-body-columns-2":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "2",
                        "question-container__steps-body-columns-3":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "3",
                        "question-container__steps-body-relation-2080":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "2" &&
                          steps[currentStep].questions[currentQuestion].primary
                            .relationship_columns === "20-80",
                        "question-container__steps-body-relation-3070":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "2" &&
                          steps[currentStep].questions[currentQuestion].primary
                            .relationship_columns === "30-70",
                        "question-container__steps-body-relation-4060":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "2" &&
                          steps[currentStep].questions[currentQuestion].primary
                            .relationship_columns === "40-60",
                        "question-container__steps-body-relation-5050":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "2" &&
                          steps[currentStep].questions[currentQuestion].primary
                            .relationship_columns === "50-50",
                        "question-container__steps-body-relation-6040":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "2" &&
                          steps[currentStep].questions[currentQuestion].primary
                            .relationship_columns === "60-40",
                        "question-container__steps-body-relation-7030":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "2" &&
                          steps[currentStep].questions[currentQuestion].primary
                            .relationship_columns === "70-30",
                        "question-container__steps-body-relation-8020":
                          steps[currentStep].questions[currentQuestion].primary
                            .columns === "2" &&
                          steps[currentStep].questions[currentQuestion].primary
                            .relationship_columns === "80-20",
                      }
                    )}
                  >
                    <div className="field-group-container">
                      <div className="question-container__steps-content">
                        <div>
                          {getCurrentQuestions()?.primary?.barrainfosuperior ===
                            "Si" && <QuoteNumberTitle />}
                          {!loading &&
                            steps[currentStep]?.questions[currentQuestion]
                              ?.primary?.title[0]?.text && (
                              <h2 className="question-container__steps-title">
                                {replaceBrand(
                                  steps[currentStep].questions[currentQuestion]
                                    .primary.title[0].text,
                                  vehicleMake,
                                  "vehiclemake"
                                )}
                              </h2>
                            )}
                          {!loading &&
                            steps[currentStep]?.questions[currentQuestion]
                              ?.primary?.description[0]?.text && (
                              <div className="question-container__steps-description">
                                {steps[currentStep].questions[currentQuestion]
                                  ?.primary?.collapse_description ? (
                                  <Collapse>
                                    <Collapse.Panel
                                      header={
                                        steps[currentStep].questions[
                                          currentQuestion
                                        ].primary.description[0].text
                                      }
                                      key="1"
                                    >
                                      {!loading &&
                                        steps[currentStep]?.questions[
                                          currentQuestion
                                        ]?.primary?.collapsable_text[0]
                                          ?.text && (
                                          <RichText
                                            render={
                                              steps[currentStep].questions[
                                                currentQuestion
                                              ].primary.collapsable_text
                                            }
                                          />
                                        )}
                                    </Collapse.Panel>
                                  </Collapse>
                                ) : (
                                  <RichText
                                    render={
                                      steps[currentStep].questions[
                                        currentQuestion
                                      ].primary.description
                                    }
                                  />
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                      <div
                        style={{position:'relative'}}
                        className={`field-group 
                        ${
                          document.getElementsByClassName(
                            "load-field__container"
                          ).length > 0 && "custom-height"
                        }
                        ${
                          document.getElementsByClassName("contractor-info")
                            .length > 0 && "custom-fields"
                        }
                        `}
                      >
                        {loading && <div className="field-group-mask"></div>}
                        {getCurrentQuestions().newItems.map((field, index) => {
                          let showField = false;
                          const fieldType =
                            field && field.customClass
                              ? field.customClass
                              : field && field.type
                              ? field.type
                              : "";
                          const totalFields =
                            steps[currentStep] &&
                            steps[currentStep].questions[currentQuestion]
                              .newItems.length;

                          setReturnButton(
                            returnButton
                              ? getCurrentQuestions().primary.returnbutton ===
                                  "Si"
                              : returnButton
                          );

                          const fieldValue =
                            field && field.conditional
                              ? formResponses.find(
                                  (value) =>
                                    value.key === field.conditional.when
                                )
                              : {};
                          showField =
                            fieldValue &&
                            Object.keys(fieldValue).length > 0 &&
                            fieldValue.value
                              ? fieldValue.value.toString() ===
                                field.conditional.eq
                                ? field.conditional.show
                                : false
                              : !(field && field.conditional);

                          disabledFields[field && field.key] = disabledFields[
                            field && field.key
                          ]
                            ? disabledFields[field && field.key]
                            : field && field.disabled
                            ? field && field.disabled
                            : false;

                          if (!showField && totalFields > 1) {
                            showField = true;
                            const key = field && field.key;
                            hiddenFields[key] =
                              hiddenFields[key] === undefined
                                ? true
                                : hiddenFields[key];
                          }

                          if (
                            field &&
                            field.type === "hidden" &&
                            formResponses.findIndex(
                              (x) => x.key === field.key
                            ) == -1
                          ) {
                            field.value = field.defaultValue;
                            formResponses.push(field);
                          }

                          if (showField) {
                            const key = `field-step-${currentStep}-${index}`;
                            return <>
                              {field.key=='serialNumber' && !isValidSerialNumber && <div className="serie">
                                <p>Serie por validar</p>
                                </div>
                              }
                              {field.key=='serialNumber' && isValidSerialNumber && <div className="serie valid">
                                <p>Serie válida</p>
                                </div>
                              }
                              {fields(
                                fieldType,
                                field,
                                form,
                                key,
                                getCurrentQuestions()
                              )}
                            </>
                          } else {
                            const currentQuestionValue = isGoToBack
                              ? currentQuestion > 0
                                ? currentQuestion - 1
                                : currentQuestion
                              : currentQuestion < numberQuestionsStep - 1
                              ? currentQuestion + 1
                              : 0;

                            const currentStepValue = isGoToBack
                              ? currentQuestion == 0
                                ? currentStep - 1
                                : currentStep
                              : currentQuestion == numberQuestionsStep - 1
                              ? currentStep + 1
                              : currentStep;

                            setFormStatus({
                              steps,
                              currentStep: currentStepValue,
                              currentQuestion: currentQuestionValue,
                              numberQuestionsStep:
                                steps[currentStepValue]?.questions.length,
                              isGoToBack: false,
                            });
                          }
                        })}
                        {keyStep=='step_emision' && !isValidSerialNumber && <div className="validate-serie">
                          <Button className="ant-btn-outline c-2 ant-btn-size-xs" loading={validating} onClick={() => {validateSerie()}}>
                            Validar Serie
                          </Button>
                         </div>
                        }
                        {keyStep=='step_inspeccion_vehicular' && <VehicleInspection numSequence={numSequence} setVehicleInspectionReady={setVehicleInspectionReady} setIsValidSerialNumber={setIsValidSerialNumber} isRecovering={isRecovering} setIsRecovering={setIsRecovering} attemptCounter={attemptCounter} setAttemptCounter={setAttemptCounter} />}
                      </div>
                    </div>
                    {getCurrentQuestions().primary.sidebar !== "No" && (
                      <div className="sidebar-container">
                        {getCurrentQuestions().primary.sidebar ===
                          "Resumen" && (
                          <SidebarResume
                            service={
                              getCurrentQuestions().primary.sidebar_service
                            }
                            form={form}
                          />
                        )}
                        {getCurrentQuestions().primary.sidebar ===
                          "Contenido" && (
                          <div className="sidebar-resume sidebar-resume-default">
                            <img
                              src={getCurrentQuestions().primary.sidebarimg.url}
                              alt=""
                            />
                            <div className="title-sidebar">
                              {getCurrentQuestions().primary.sidebarimg.alt}
                            </div>
                          </div>
                        )}
                        <div className="sidebar-container-btn">
                          {continueBtn()}
                        </div>
                      </div>
                    )}
                  </Form>
                )}

                {steps[currentStep]?.questions[currentQuestion]?.primary
                  ?.enable_email === "Si" && (
                  <div className="question-container__steps-support">
                    <RichText render={info.data.email_info} />
                  </div>
                )}
              </div>
            )}
            {getCurrentQuestions()?.primary?.sidebar === "No" && continueBtn()}
          </div>
        </div>
      </GoogleReCaptchaProvider>
    )
  );
}
